<template>
  <div class="left_top_echart">
    <div class="fluct">
      <div class="title">价格波动</div>
      <div class="select">
        <!-- <el-select class="small-select" size="mini" placeholder="广东" popper-class="custom-selector">
          <el-option></el-option>
        </el-select> -->
        <el-select
          class="small-select"
          size="mini"
          v-model="marketsValue"
          placeholder="市场"
          popper-class="custom-selector"
          @change="changeMarket(marketsValue)"
          :title="marketsValue"
        >
          <el-option v-for="item in markets" :key="item" :label="item" :value="item"></el-option>
        </el-select>
        <el-select
          class="small-select"
          size="mini"
          v-model="varietyValue"
          placeholder="品种"
          popper-class="custom-selector"
          @change="changeVariety(varietyValue)"
           :title="varietyValue"
        >
          <el-option v-for="item in variety" :key="item" :label="item" :value="item"  ></el-option>
        </el-select>
      </div>
    </div>
    <div id="price_echart" ref="priceEchart"></div>
    <div class="info_table">
      <el-table
        :data="tableData"
        style="width: 100%"
        :header-row-style="getRowClass"
        :header-cell-style="getRowClass"
        :row-class-name="tableRowClassName"
      >
        <el-table-column prop="dataDate" label="时间" width="108"></el-table-column>
        <el-table-column prop="varietyName" label="产品/品种" scope="scope" width="118"></el-table-column>
        <el-table-column prop="originalPlace" label="所在产地" show-overflow-tooltip width="100"></el-table-column>
        <el-table-column prop="price" label="价格" width="82"></el-table-column>
        <el-table-column prop="varyRatio" label="升降">
          <template slot-scope="scope">
            <span v-if="scope.row.varyRatio < 0" style="color: #7FFFA0">{{scope.row.varyRatio}}</span>
            <span v-else style="color: #FF7F95 ">{{scope.row.varyRatio}}</span>
          </template>
        </el-table-column>
      </el-table>
    </div>
  </div>
</template>
<script>
var echarts = require("echarts");
export default {
  data() {
    return {
      cities: [],
      markets: [],
      marketsValue: "",
      variety: [],
      varietyValue: "",
      valueCity: "",
      valueMarket: "",
      valueType: "",
      res: {},
      tableData: [],
      priceData: []
    };
  },
  created() {
    this.changesr();
    this.palys();
  },
  async mounted() {
    await this.$axios
      .get("/bigdata/index/getFluctuationPriceData")
      .then(res => {
   
        this.markets = res.data.originalPlaceList;
        this.marketsValue= res.data.originalPlace;
        this.variety = res.data.varietyNameList;
        this.varietyValue = res.data.varietyName;
        this.priceData = res.data.priceDataTop7
      })
      .catch(res => {
        console.log(res);
      });

       await this.$axios
      .get("bigdata/index/getNewestMarketPriceData")
      .then(res => {
        this.tableData = res.data.newestPriceData;
      })
      .catch(res => {
        console.log(res);
      });
    this.PriceEchart();
  },
  methods: {
    PriceEchart() {
      let myCharts = this.$echarts.init(this.$refs.priceEchart);
      let dataX =[];
      let data = [];
      let Icon = [];
      Icon.push(this.varietyValue)
      for(let i = 0; i < this.priceData.length; i++) {
        dataX.push(this.priceData[i].date);
        data.push(parseInt(this.priceData[i].price));
      }
      myCharts.setOption({
        tooltip: {
          trigger: "axis",
          formatter: function(params) {
            var relVal = params[0].name;
            for (var i = 0, l = params.length; i < l; i++) {
              relVal +=
                "<br/>" +
                params[i].marker +
                params[i].seriesName +
                " : " +
                params[i].value +
                "元/千克";
            }
            return relVal;
          }
        },
        legend: {
          data: Icon,
          top: 25,
          textStyle: {
            fontSize: 14, //字体大小
            color: "rgba(255,255,255,0.5)" //字体颜色
          }
        },
        grid: {
          left: "8%",
          right: "8%",
          bottom: "3%",
          containLabel: true
        },
        toolbox: {
          feature: {
            saveAsImage: {
              show: false
            }
          }
        },
        xAxis: {
          type: "category",
          boundaryGap: false,
          axisLabel: {
            show: true,
            textStyle: {
              color: "rgba(255,255,255,0.5)"
            }
          },
          axisLine: {
            lineStyle: {
              color: "rgba(74,174,255,0.3)",
              width: 0.5
            }
          },
          data: dataX
        },
        yAxis: {
          name: "(元/千克)",
          nameTextStyle: {
            color: "rgba(255,255,255,0.5)",
            fontSize: 12,
            padding: [0, 0, 0, -5]
          },
          type: "value",
          max: 10,
          min: 0,
          splitNumber: 6,
          axisLine: {
            show: false
          },
          splitLine: {
            lineStyle: {
              type: "dashed",
              color: "#092439"
            }
          },
          axisLabel: {
            show: true,
            textStyle: {
              color: "rgba(255,255,255,0.5)"
            }
          }
        },
        series: [
          {
            name: this.varietyValue,
            type: "line",
            smooth: true,
            data: data,
            itemStyle: {
              normal: {
                color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                  { offset: 0, color: "#61FEE6" },
                  { offset: 0.5, color: "#61FEE6" },
                  { offset: 1, color: "#00FFBA" }
                ])
              }
            }
          }
        ]
      });
    },
    getRowClass() {
      return "background: transparent;";
    },
    changesr() {
      if (this.tableData.length > 4) {
        this.tableData.push(this.tableData[0]);
        this.tableData.shift();
      }
    },
    palys() {
      setInterval(this.changesr, 2000);
    },
    //添加表格基数偶数行class名
    tableRowClassName({ rowIndex }) {
      if (rowIndex % 2 == 1) {
        return "warning-row";
      } else {
        return "success-row";
      }
    },
    //修改市场
    changeMarket(value) {
      this.$axios
      .get("/bigdata/index/getAllVarietyNameByOriginalPlace", {
        params: {
          originalPlace: value
        }
      })
      .then(res => {
        this.varietyValue = ''
        this.variety = res.data.varietyNameList;
      })
      .catch(res => {
        console.log(res);
      });
    },
    //选择品种
    changeVariety(value) {
       this.$axios
      .get("/bigdata/index/getFluctuationPriceData", {
        params: {
          varietyName: value,
          originalPlace: this.marketsValue
        }
      })
      .then(res => {
         this.priceData = res.data.priceDataTop7
          this.PriceEchart();
      })
      .catch(res => {
        console.log(res);
      });
    }
  }
};
</script>
<style lang="scss" scoped>
.left_top_echart {
  width: 100%;
  height: 100%;
  .fluct {
    width: 100%;
    height: 45px;
    justify-content: space-between;
  }
  #price_echart {
    width: 100%;
    height: 180px;
    box-sizing: border-box;
    margin-top: 8px;
  }
  .reportChartCon .circle {
    font-size: 8px;
  }
  .reportChartCon .circle > span {
    display: inline-block;
    height: 6px;
    width: 6px;
    margin-right: 5px;
    vertical-align: middle;
    border-radius: 3px;
  }
}
.select {
  height: 35px;
  margin-right: 0px;
  display: flex;
  justify-content: flex-end;
  padding-right: 20px;
}
.small-select {
  width: 102px;
  height: 34px;
  font-size: 14px;
  background: url("../../../assets/bgIcon/select.png") no-repeat;
  background-size: 100% 100%;
}
.info_table {
  width: 99%;
  height: 200px;
  padding: 20px 20px 0 20px;
  box-sizing: border-box;
  overflow: hidden;
  .el-table {
    width: 95%;
    height: 97%;
  }
}
</style>

<style lang='scss'>
.el-table .warning-row {
  background-color: transparent;
}
.el-table .success-row {
  // background: #0efff127;
  background: rgba(14, 255, 241, 0.05);
}
.custom-selector {
  background: rgba(74, 222, 255, 0.3) !important;
  border: 1px solid rgba(74, 174, 255, 0.3) !important;
  border-radius: 0 !important;
  font-weight: bold;
}

.el-select-dropdown__item {
  color: white !important;
}
.el-input--mini {
  font-size: 14px !important;
  .el-input__inner {
    height: 35px !important;
    line-height: 35px !important;
  }
}

.el-select-dropdown__item.hover {
  background-color: rgba(5, 159, 203, 0.4) !important;
  color: rgba(255, 255, 255, 0.4) !important;
}

.popper__arrow {
  display: none !important;
}

.el-popper[x-placement^="bottom"] {
  margin-top: 1px !important;
}

.el-input__inner {
  background: url("../../../assets/bgIcon/select.png") no-repeat !important;
  border: none !important;
  display: flex !important;
  justify-content: center !important;
  align-items: center !important;
  text-align: center;
  color: rgba(255, 255, 255, 1) !important;
}

.el-input__inner::placeholder {
  color: rgba(255, 255, 255, 1) !important;
}
.el-select-dropdown__item {
  color: rgba(255, 255, 255, 1) !important;
}

.el-input--mini .el-input__inner {
  height: auto !important;
}

.el-table::before {
  content: "";
  position: absolute;
  background-color: transparent !important;
  z-index: -1 !important;
}
.el-table td,
.el-table th {
  padding: 0 !important;
  text-align: center !important;
}
.el-table__header {
  color: #ccd0d4;
}
.el-table thead {
  color: rgba(204, 204, 204, 1) !important;
  font-size: 12px;
}
.el-table__body-wrapper {
  width: 100%;
  color: #ccd0d4;
  .el-table__body {
    width: 100% !important;
    tr {
      td {
        .cell {
          font-size: 14px;
          line-height: 30px;
          color: rgba(255, 255, 255, 1);
          padding-left: 0px;
        }
      }
    }
  }
}
.info_table /deep/ .el-table,
.el-table__expanded-cell {
  background-color: transparent;
}
.info_table /deep/ .el-table .el-table__header-wrapper .el-table__header {
  width: 100% !important;
  background-color: transparent !important;
  .has-gutter {
    width: 100% !important;
  }
}
.info_table /deep/ .el-table .el-table__header-wrapper .el-table__header tr {
  width: 100% !important;
  background-color: transparent !important;
  transition: top 0.825s !important;
  th {
    border: none;
    margin-bottom: 18px !important;
  }
}
.info_table
  /deep/
  .el-table
  .el-table__header-wrapper
  .el-table__header
  .gutter {
  background-color: transparent !important;
  width: 100% !important;
}

.info_table /deep/ .el-table--enable-row-transition .el-table__body td,
.el-table .cell {
  background-color: transparent;
  border: none;
}

.el-table--enable-row-hover .el-table__body tr:hover > td {
  background-color: #212e3e !important;
}
/deep/ .el-table tbody tr:hover > td {
  background-color: #31c7ff;
}
</style>